import React, { CSSProperties } from "react"
import HTMLEditTextDialog from "./HTMLEditTextDialog"
import { red500 } from "material-ui/styles/colors"
interface IProps {
    style?: CSSProperties
    readonly?: boolean
    identifier: string
    title?: string
    titleStyle?: CSSProperties
    error?: string
    errorStyle?: CSSProperties
    value: string
    textStyle?: CSSProperties
    handleChange(value: string): void
}
interface IState {
    openEditorDialog: boolean
}

export default class HTMLEditText extends React.Component<IProps, IState> {
    private htmlViewer
    constructor(props) {
        super(props)
        this.state = {
            openEditorDialog: false
        }
    }

    componentDidMount() {
        this.htmlViewer = document.getElementById(this.props.identifier)
        this.htmlViewer.innerHTML = this.props.value
    }

    render() {
        return (
            <div
                style={{ ...this.props.style, position: "relative" }}
                onClick={() => !this.props.readonly && this.setState({ openEditorDialog: true })}
            >
                {this.props.title &&
                    <div style={{ ...this.props.titleStyle, fontSize: 12, color: "rgba(0, 0, 0, 0.3)", marginBottom: 8 }}>{this.props.title}</div>
                }
                <div
                    id={this.props.identifier}
                    style={{ ...this.props.textStyle, borderBottom: "1px solid rgb(224, 224, 224)", minHeight: 13 }}
                />
                {this.state.openEditorDialog &&
                    <HTMLEditTextDialog
                        value={this.props.value}
                        handleSave={value => {
                            this.setState({ openEditorDialog: false })
                            this.htmlViewer.innerHTML = value
                            this.props.handleChange(value)
                        }}
                    />
                }
                {this.props.error &&
                    <div style={{ ...this.props.style, position: "absolute", color: red500, fontSize: 12, bottom: -23 }}>{this.props.error}</div>
                }
            </div>
        )
    }
}